export default "__VITE_ASSET__CkF_2bzG__"